import {http} from '../config/config-receituario'

export default{
    listar:(token)=>{
        return  http.get('tipo-produto',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, tipoProduto)=>{
        return http.post('tipo-produto',tipoProduto,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, id)=>{
        return http.delete(`tipo-produto/${id}`,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, tipoProduto)=>{
        console.log(tipoProduto);
        return http.put(`tipo-produto/${tipoProduto.id}`, tipoProduto,{
            headers:{
                'Authorization':token
            }
        })
    }

}